export const GET_DASHBOARD = "GET_DASHBOARD";
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_DASHBOARD_FAILURE = "GET_DASHBOARD_FAILURE";
export const RESET_DASHBOARD = "RESET_DASHBOARD";

export interface DashboardState {
  dashboardList: any;
  dashboardSuccess: string | null;
  dashboardError: string | null;
  dashboardLoading: boolean;
}

interface GetDashboardAction {
  type: typeof GET_DASHBOARD;
  payload: any;
}

interface GetDashboardSucess {
  type: typeof GET_DASHBOARD_SUCCESS;
  payload: any;
}

interface GetDashboardFailure {
  type: typeof GET_DASHBOARD_FAILURE;
  payload: string;
}

interface ResetDashboardAction {
  type: typeof RESET_DASHBOARD;
}

export type DashboardActionTypes =
  | GetDashboardAction
  | GetDashboardSucess
  | GetDashboardFailure
  | ResetDashboardAction;
